import type {
  IDecimalValueAndUnit,
  IDeliverySites,
  IDigestateJob,
  IEmployees,
  IFarms,
  IJobSiteInfo,
  IProduct,
  ISilos,
  ITrailers,
  IVehicles
} from '@/interfaces'
import Base from '../Base'
import { type JobStatusType } from '@/enum'
import type JobStatusChange from '../JobStatusChange'
import JobSiteInfo from '../JobSiteInfo'
import PriceWithUnit from '../PriceWithUnit'

class DigestateJob extends Base implements IDigestateJob {
  number: string
  description: string
  status: JobStatusType
  scheduleDate: string
  pickupADPlantSiteId: string
  pickupADPlantSite: IDeliverySites
  collectionSiteInfo: IJobSiteInfo
  farmId: string
  farm: IFarms
  digestateProductId: string | null
  digestateProduct: IProduct
  siloId: string | null
  silo: ISilos
  assignedEmployeeId: string
  assignedEmployee: IEmployees
  assignedVehicleId: string
  assignedVehicle: IVehicles
  assignedEquipmentId: string
  assignedEquipment: ITrailers
  isRepeatable: boolean
  notes: string
  completedAt: string
  statusChangeHistory: JobStatusChange[]
  price: IDecimalValueAndUnit

  constructor(jobData?: any) {
    super(jobData)
    this.number = jobData?.number
    this.status = jobData?.status
    this.scheduleDate = jobData?.scheduleDate
    this.pickupADPlantSiteId = jobData?.pickupADPlantSiteId
    this.pickupADPlantSite = jobData?.pickupADPlantSite
    this.collectionSiteInfo = jobData?.collectionSiteInfo ?? new JobSiteInfo()
    this.farmId = jobData?.farmId
    this.farm = jobData?.farm
    this.digestateProductId = jobData?.digestateProductId
    this.digestateProduct = jobData?.digestateProduct
    this.siloId = jobData?.siloId
    this.silo = jobData?.silo
    this.assignedEmployeeId = jobData?.assignedEmployeeId
    this.assignedEmployee = jobData?.assignedEmployee
    this.assignedVehicleId = jobData?.assignedVehicleId
    this.assignedVehicle = jobData?.assignedVehicle
    this.assignedEquipmentId = jobData?.assignedEquipmentId
    this.assignedEquipment = jobData?.assignedEquipment
    this.isRepeatable = jobData?.isRepeatable
    this.notes = jobData?.notes
    this.description = jobData?.description
    this.completedAt = jobData?.completedAt
    this.statusChangeHistory = jobData?.statusChangeHistory
    this.price = new PriceWithUnit(jobData?.price)
  }
}

export default DigestateJob
